import { DataTable } from 'primereact/datatable'
import { Btn, CustomModal } from '../../../../../components'
import React from 'react'
import { Column } from 'primereact/column'

export default function ModalMovimentacaoEstoqueAvulso({
  onRemove,
  isVisible,
  onClose,
  movimentacoes,
}) {
  return (
    <CustomModal header="Movimentações" isVisible={isVisible} onClose={onClose} width={650}>
      <DataTable value={movimentacoes} paginator={true} rows={10}>
        <Column field="endereco" header="Endereço" />
        <Column field="quantidade" header="Quantidade" />
        <Column field="validade" header="Validade" />
        <Column field="lote" header="Lote" />
        <Column header="" body={value => <Btn onClick={() => onRemove(value)}>Remover</Btn>} />
      </DataTable>
    </CustomModal>
  )
}
